import React, { FC } from 'react';
import { Checkbox } from 'antd';
import { CheckboxProps } from 'antd';

import './styles.scss';

const CheckBox: FC<CheckboxProps> = ({ children, ...props }) => (
  <Checkbox {...props} className="custom-check-box">
    {children}
  </Checkbox>
);
export default CheckBox;
